module.exports = "/_next/static/images/wisconsin-887a7e323d160587b567cc8f36f64d66.svg";